import { useCallback, useLayoutEffect, useRef } from "react"
import { useSearchParams } from "react-router-dom"

type UsePagination = () => {
  page: number
  pageSize: number
  setPage: (p: number) => void
  setPageSize: (size: number) => void
}

export const usePagination: UsePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const paramsRef = useRef(searchParams)
  paramsRef.current = searchParams

  const page = Number(searchParams.get("page") || 1)
  const pageSize = Number(searchParams.get("pageSize") || 10)

  const setParams = useCallback(
    (next: Record<string, string | null>) => {
      const params = new URLSearchParams(paramsRef.current)

      Object.entries(next).forEach(([key, value]) => {
        if (value) params.set(key, value)
        else params.delete(key)
      })

      paramsRef.current = params
      setSearchParams(params)
    },
    [setSearchParams]
  )

  const setPage = useCallback((p: number) => setParams({ page: String(p) }), [setParams])

  const setPageSize = useCallback((size: number) => setParams({ pageSize: String(size), page: "1" }), [setParams])

  useLayoutEffect(() => {
    const curentPage = searchParams.get("page")
    const curentPageSize = searchParams.get("pageSize")

    if (!curentPage) setPage(1)

    if (!curentPageSize) setPageSize(10)
  }, [searchParams, setPage, setPageSize])

  return {
    page,
    pageSize,
    setPage,
    setPageSize,
  }
}
